"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const order_fragment_1 = __importDefault(require("../fragments/order.fragment"));
const mutation = (0, client_1.gql) `
mutation multipleBreakApartOrder($orderId: [String]!) {
    multipleBreakApartOrder(orderId: $orderId) {
      _id
    userId
    organization {
      orgName
      ticketFormat
    }
    user {
      email
      firstName
      lastName
    }
      event {
        _id
        isMultipleDays
        name
        subtitle
        performances {
          schedule {
            doorsAt
            startsAt
            __typename
          }
          __typename
        }
        venue {
          _id
          name
          address {
            state
            city
            timezone
            __typename
          }
          __typename
        }
        __typename
      }
      type
      ...OrderTickets
      ...OrderUpgrades
      __typename
    }
  }
  
  ${order_fragment_1.default.fragments.tickets}
  ${order_fragment_1.default.fragments.upgrades}
`;
exports.default = mutation;
//# sourceMappingURL=multipleBreakApartOrder.mutation.js.map